/*!
 * Zaverni Tracker v1.0.0 — 全站细粒度行为埋点
 * ---------------------------------------------------------------
 * 记录内容：
 *   来源归因（UTM / gclid / fbclid / 引荐分类：搜索/社交/邮件/直接）
 *   浏览路径（landing → 中间页 → 退出页，软导航/bfcache 均捕获）
 *   停留时长（可见时间累计，切后台暂停）
 *   滚动深度（25/50/75/90/100% 里程碑）
 *   点击行为（元素路径 / 文案 / 坐标 / 是否外链）
 *   电商漏斗（view_item → add_to_cart → remove_from_cart → begin_checkout → purchase_view）
 *   离站行为（page_exit + exit_intent）
 *   匿名身份：localStorage uid + cookie 双写 + 浏览器指纹兜底（清缓存也能认出）
 *   登录态识别：Shopify customer（email 仅存 SHA-256）
 *
 * 零依赖，ES5 兼容语法，约 20KB。配置见 snippets/zaverni-tracking.liquid
 * 采集服务端见 tools/tracking/collector.py
 */
(function (window, document, navigator) {
  'use strict';
  if (window.__ZV_TRACK__) return;
  window.__ZV_TRACK__ = true;

  /* ---------------- 配置 ---------------- */
  var CFG = {
    endpoint: '',                 // 采集服务地址，如 https://zv-collect.your-domain.com（末尾不带斜杠）
    siteId: 'zaverni-main',
    sessionTimeoutMin: 30,        // 无操作多少分钟算新会话
    batchMs: 8000,                // 批量发送间隔
    heartbeatMs: 15000,           // 在线心跳（累计停留时间）
    maxQueue: 500,                // 离线队列上限
    scrollMilestones: [10, 25, 50, 75, 90, 100],
    trackClicks: true,            // 全站点击捕获
    trackForms: true,             // 邮箱订阅 / 搜索框交互
    token: ''                     // 采集服务令牌（collector 端 ZV_TOKEN 设置后才需要）
  };
  var userCfg = window.ZV_TRACK_CONFIG || {};
  for (var ck in userCfg) if (Object.prototype.hasOwnProperty.call(userCfg, ck)) CFG[ck] = userCfg[ck];

  if (!CFG.endpoint) {
    if (window.console && console.warn) console.warn('[zv-track] endpoint 未配置，埋点不发送');
    return;
  }
  // 同意门控（如部署 Cookie 同意横幅，勾选后再置 localStorage.zv_consent='granted'）
  if (CFG.requireConsent) {
    try { if (localStorage.getItem('zv_consent') !== 'granted') return; } catch (e) { return; }
  }

  var ENDPOINT = CFG.endpoint.replace(/\/+$/, '');
  var log = function () { if (CFG.debug && window.console && console.log) console.log.apply(console, arguments); };

  /* ---------------- 存储 helpers（隐私模式降级到 cookie/内存） ---------------- */
  var memStore = {};
  function ls(k, v) {
    try {
      if (v === undefined) return localStorage.getItem(k);
      localStorage.setItem(k, v);
      return v;
    } catch (e) {
      if (v === undefined) return (k in memStore) ? memStore[k] : null;
      memStore[k] = v; return v;
    }
  }
  function cookie(k, v, days) {
    if (v === undefined) {
      var m = document.cookie.match(new RegExp('(^|;\\s*)' + k.replace(/([.*+?^${}()|[\]\\])/g, '\\$1') + '=([^;]*)'));
      return m ? decodeURIComponent(m[2]) : null;
    }
    var d = new Date(); d.setTime(d.getTime() + (days || 365) * 864e5);
    document.cookie = k + '=' + encodeURIComponent(v) + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
    return v;
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }
  function hash32(str) {
    var h = 0x811c9dc5, i;
    for (i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = (h * 0x01000193) >>> 0; }
    return ('00000000' + h.toString(36)).slice(-8) + str.length.toString(36);
  }

  /* ---------------- 身份：uid + 指纹 ---------------- */
  function fingerprint() {
    var parts = [];
    try {
      parts.push(navigator.userAgent || '');
      parts.push(navigator.language || '');
      parts.push((screen.width || 0) + 'x' + (screen.height || 0) + 'x' + (screen.colorDepth || 0));
      parts.push(String(new Date().getTimezoneOffset()));
      parts.push(String(navigator.hardwareConcurrency || 0));
      parts.push(navigator.platform || '');
      var cv = document.createElement('canvas'), cx;
      if (cv.getContext) {
        cx = cv.getContext('2d');
        cx.textBaseline = 'top'; cx.font = '14px "Arial"';
        cx.fillStyle = '#f60'; cx.fillRect(0, 0, 80, 20);
        cx.fillStyle = '#069'; cx.fillText('zaverni', 2, 2);
        cx.strokeStyle = 'rgba(102,204,0,0.7)'; cx.arc(50, 50, 50, 0, Math.PI * 2, true);
        parts.push(cv.toDataURL());
      }
      if (window.Intl && Intl.DateTimeFormat) {
        parts.push(String(new Intl.DateTimeFormat().resolvedOptions().timeZone || ''));
      }
    } catch (e) { /* 指纹尽力而为 */ }
    return hash32(parts.join('||'));
  }

  var FP = fingerprint();
  var UID = null;

  function saveIdentity(uid) {
    UID = uid;
    ls('zv_uid', uid);
    cookie('zv_uid', uid, 365);
    ls('zv_uid_fp_' + FP, uid); // 指纹镜像：localStorage 被清后仍可自恢复
  }

  (function resolveIdentity() {
    UID = ls('zv_uid') || cookie('zv_uid') || ls('zv_uid_fp_' + FP);
    if (UID) { saveIdentity(UID); return; }
    // 本地全无 → 问服务端该指纹是否见过（换浏览器/清缓存/换设备场景由服务端 fp_map 兜底）
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', ENDPOINT + '/zv/resolve?site=' + encodeURIComponent(CFG.siteId) + '&fp=' + FP, true);
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          try {
            var j = JSON.parse(xhr.responseText);
            if (j && j.uid) { saveIdentity(j.uid); log('[zv-track] 服务端指纹找回 uid', j.uid); }
          } catch (e) { /* ignore */ }
        }
      };
      xhr.send();
    } catch (e) { /* ignore */ }
    UID = uuid();
    saveIdentity(UID);
  })();

  /* ---------------- 会话 ---------------- */
  var now0 = Date.now();
  function getSession(now) {
    var sid = ls('zv_sid'), last = parseInt(ls('zv_last_activity') || '0', 10), start = parseInt(ls('zv_session_start') || '0', 10);
    var timeout = CFG.sessionTimeoutMin * 60000;
    var isNew = !sid || !last || (now - last > timeout);
    if (isNew) {
      sid = uuid();
      ls('zv_sid', sid);
      ls('zv_session_start', now);
      ls('zv_session_index', String((parseInt(ls('zv_session_index') || '0', 10) || 0) + 1));
    }
    ls('zv_last_activity', now);
    return { sid: sid, isNew: isNew, start: parseInt(ls('zv_session_start'), 10) || now, index: parseInt(ls('zv_session_index'), 10) || 1 };
  }

  /* ---------------- 归因 ---------------- */
  var SEARCH_ENGINES = {
    'google': 'google', 'bing': 'bing', 'baidu': 'baidu', 'yahoo': 'yahoo', 'duckduckgo': 'duckduckgo',
    'ecosia': 'ecosia', 'yandex': 'yandex', 'naver': 'naver'
  };
  var SOCIAL_NETS = {
    'facebook': 'facebook', 'fb': 'facebook', 'instagram': 'instagram', 'tiktok': 'tiktok',
    'twitter': 'twitter', 'x': 'twitter', 'pinterest': 'pinterest', 'reddit': 'reddit',
    'youtube': 'youtube', 'linkedin': 'linkedin', 't.co': 'twitter'
  };
  function hostOf(url) { try { return new URL(url, location.href).hostname.replace(/^www\./, '').toLowerCase(); } catch (e) { return ''; } }
  function parseUtm(q) {
    var out = {};
    (q || '').replace(/^\?/, '').split('&').forEach(function (kv) {
      if (!kv) return;
      var p = kv.split('='), k = decodeURIComponent(p[0]).toLowerCase(), v = decodeURIComponent((p[1] || '').replace(/\+/g, ' '));
      if (k.indexOf('utm_') === 0 || ['gclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'li_fat_id', 'yclid'].indexOf(k) >= 0) out[k] = v;
    });
    return out;
  }
  function classifySource(referrer, query) {
    var utm = parseUtm(query), q;
    var clickIds = ['gclid', 'fbclid', 'msclkid', 'ttclid', 'twclid', 'yclid'];
    for (q = 0; q < clickIds.length; q++) if (utm[clickIds[q]]) utm.utm_source = utm.utm_source || clickIds[q].replace('clid', '');
    var refHost = referrer ? hostOf(referrer) : '';
    var out = {
      source_type: 'direct', source_name: 'direct',
      utm: utm, referrer_host: refHost,
      referrer_path: '', search_engine: '', is_internal: false
    };
    try { out.referrer_path = referrer ? new URL(referrer).pathname + new URL(referrer).search : ''; } catch (e) { /* noop */ }
    if (utm.utm_source) { out.source_type = 'campaign'; out.source_name = utm.utm_source; return out; }
    if (!referrer) { out.source_type = 'direct'; out.source_name = 'direct'; return out; }
    if (refHost === location.hostname.replace(/^www\./, '').toLowerCase()) {
      out.source_type = 'internal'; out.source_name = 'internal'; out.is_internal = true; return out;
    }
    var reg = /([a-z0-9-]+)\.(com|net|org|co|io|ru|cn|de|fr|es|jp|kr|it|nl|se|no|dk|fi|pl|cz|pt|br|mx|in|au|ca|uk|tv|me|ai|app|dev)$/.exec(refHost);
    var name = reg ? reg[1] : refHost;
    if (SEARCH_ENGINES[name]) { out.source_type = 'search'; out.source_name = SEARCH_ENGINES[name]; out.search_engine = SEARCH_ENGINES[name]; return out; }
    if (SOCIAL_NETS[name]) { out.source_type = 'social'; out.source_name = SOCIAL_NETS[name]; return out; }
    if (/^(e\.|email|mail|newsletter|klaviyo|mailchimp)/.test(name)) { out.source_type = 'email'; out.source_name = name; return out; }
    out.source_type = 'referral'; out.source_name = name; return out;
  }

  // 首触 / 末触归因持久化（永不覆盖 first）
  function persistAttribution(src) {
    var first = ls('zv_attr_first');
    if (!first && src.source_type !== 'internal') {
      ls('zv_attr_first', JSON.stringify({ ts: Date.now(), url: location.href, source: src.source_name, source_type: src.source_type }));
    }
    if (src.source_type !== 'internal') ls('zv_attr_last', JSON.stringify({ ts: Date.now(), url: location.href, source: src.source_name, source_type: src.source_type }));
    try { if (src.utm && Object.keys(src.utm).length) { ls('zv_attr_utm', JSON.stringify(src.utm)); } } catch (e) { /* noop */ }
  }
  function readStoredAttribution() {
    try { return JSON.parse(ls('zv_attr_first') || 'null'); } catch (e) { return null; }
  }

  /* ---------------- 环境上下文 ---------------- */
  function deviceType() {
    var ua = navigator.userAgent || '';
    if (/iPad|Tablet|(?!.*Mobile)Silk|PlayBook|Nexus 7|Nexus 10/.test(ua)) return 'tablet';
    if (/Mobi|iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry|Opera Mini|IEMobile/.test(ua)) return 'mobile';
    return 'desktop';
  }
  function baseContext() {
    var src = classifySource(document.referrer, location.search);
    return {
      uid: UID, fp: FP, sid: SESS.sid, session_index: SESS.index,
      site: CFG.siteId,
      ts: Date.now(),
      url: location.href, path: location.pathname, query: location.search,
      hash: location.hash, title: document.title,
      referrer: document.referrer || '',
      source_type: src.source_type, source_name: src.source_name,
      utm: src.utm, search_engine: src.search_engine,
      referrer_host: src.referrer_host,
      viewport: window.innerWidth + 'x' + window.innerHeight,
      screen: (screen.width || 0) + 'x' + (screen.height || 0),
      device: deviceType(),
      lang: navigator.language || '',
      tz: (function () { try { return Intl.DateTimeFormat().resolvedOptions().timeZone || ''; } catch (e) { return ''; } })(),
      template: (window.ZV_PAGE && window.ZV_PAGE.template) || document.body.getAttribute('data-template') || ''
    };
  }

  /* ---------------- 队列与发送 ---------------- */
  var queue = [];
  try { queue = JSON.parse(ls('zv_queue') || '[]'); } catch (e) { queue = []; }

  function persistQueue() {
    try { ls('zv_queue', JSON.stringify(queue.slice(-CFG.maxQueue))); } catch (e) { /* quota */ }
  }
  function track(type, data, silent) {
    var ev = baseContext();
    ev.type = type;
    ev.payload = data || {};
    queue.push(ev);
    persistQueue();
    if (!silent) maybeFlush();
    log('[zv-track]', type, data);
  }
  function maybeFlush() {
    if (queue.length >= 50) flush(false);
  }
  function flush(useBeacon) {
    if (!queue.length) return;
    var batch = queue.splice(0, 100);
    persistQueue();
    var body = JSON.stringify({ site: CFG.siteId, token: CFG.token, batch: batch });
    var url = ENDPOINT + '/zv/collect';
    if (useBeacon && navigator.sendBeacon) {
      try {
        var ok = navigator.sendBeacon(url, new Blob([body], { type: 'text/plain' }));
        if (ok) { log('[zv-track] beacon 发送', batch.length); return; }
      } catch (e) { /* fallthrough fetch */ }
    }
    try {
      fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain' },
        body: body,
        keepalive: true,
        mode: 'cors'
      }).then(function () {
        log('[zv-track] fetch 发送', batch.length);
      }).catch(function () {
        queue = batch.concat(queue).slice(-CFG.maxQueue); // 失败回队列重试
        persistQueue();
      });
    } catch (e) {
      queue = batch.concat(queue).slice(-CFG.maxQueue);
      persistQueue();
    }
  }

  /* ---------------- 会话启动 ---------------- */
  var SESS = getSession(now0);
  var SRC = classifySource(document.referrer, location.search);
  persistAttribution(SRC);

  /* ---------------- 首次访问标记 ---------------- */
  if (!ls('zv_first_visit')) {
    ls('zv_first_visit', String(now0));
    track('first_visit', { first_visit_ts: now0, landing_url: location.href, landing_referrer: document.referrer || '' });
  }

  var PAGE_ENTER = Date.now();
  var visibleSince = PAGE_ENTER;
  var engagedMs = 0;
  var maxScrollPct = 0;
  var firedMilestones = {};
  var pageExitFired = false;
  var lastHref = location.href;
  var entryType = 'landing';
  var navEntry = null;
  try {
    var navs = performance.getEntriesByType && performance.getEntriesByType('navigation');
    if (navs && navs.length) {
      navEntry = navs[0];
      entryType = navEntry.type === 'reload' ? 'reload' : 'navigation';
    }
  } catch (e) { /* noop */ }

  /* ---------------- 页面浏览 ---------------- */
  function perfData() {
    var p = {};
    try {
      if (navEntry) {
        p.dns_ms = Math.round(navEntry.domainLookupEnd - navEntry.domainLookupStart);
        p.tcp_ms = Math.round(navEntry.connectEnd - navEntry.connectStart);
        p.ttfb_ms = Math.round(navEntry.responseStart - navEntry.requestStart);
        p.dom_ms = Math.round(navEntry.domContentLoadedEventEnd - navEntry.startTime);
        p.load_ms = Math.round(navEntry.loadEventEnd - navEntry.startTime);
      }
      var paints = performance.getEntriesByType ? performance.getEntriesByType('paint') : [];
      for (var i = 0; i < paints.length; i++) if (paints[i].name === 'first-contentful-paint') p.fcp_ms = Math.round(paints[i].startTime);
    } catch (e) { /* noop */ }
    return p;
  }

  function onPageView(reason) {
    PAGE_ENTER = Date.now();
    visibleSince = PAGE_ENTER;
    engagedMs = 0;
    maxScrollPct = 0;
    firedMilestones = {};
    pageExitFired = false;
    var src = classifySource(document.referrer, location.search);
    var storedFirst = readStoredAttribution();
    track('page_view', {
      entry_type: reason || entryType,           // landing / reload / navigation / soft / bfcache / focus
      is_landing: !!(reason || entryType) && (reason || entryType) === 'landing',
      source_type: src.source_type,
      source_name: src.source_name,
      utm: src.utm,
      search_engine: src.search_engine,
      referrer: document.referrer || '',
      referrer_host: src.referrer_host,
      first_touch: storedFirst ? { source: storedFirst.source, source_type: storedFirst.source_type, url: storedFirst.url, ts: storedFirst.ts } : null,
      perf: perfData(),
      session_start: SESS.isNew,
      visit_number: SESS.index,
      page: pageMeta()
    });
    if (reason === 'landing' || SESS.isNew) {
      track('session_start', {
        source_type: src.source_type, source_name: src.source_name,
        utm: src.utm, referrer: document.referrer || '', device: deviceType(),
        viewport: window.innerWidth + 'x' + window.innerHeight,
        lang: navigator.language, first_touch: storedFirst ? storedFirst.source : null
      });
      SESS.isNew = false;
    }
    // 产品 / 集合页自动 view_item / view_collection
    var pm = pageMeta();
    if (pm.product_id) track('view_item', { product_id: pm.product_id, product_title: pm.product_title, price: pm.price, currency: pm.currency, variant_id: pm.variant_id });
    if (pm.collection_handle) track('view_collection', { collection_handle: pm.collection_handle, collection_title: pm.collection_title });
    if (pm.page_type === 'order_status' || /^\/orders\/|\/thank_you/.test(location.pathname)) {
      track('purchase_view', { order_token: (location.pathname.match(/orders\/([^/?#]+)/) || [])[1] || '', url: location.href });
    }
  }

  function pageMeta() {
    if (window.ZV_PAGE) return window.ZV_PAGE;
    return { template: document.body.getAttribute('data-template') || '', page_type: '' };
  }

  /* ---------------- 滚动深度 ---------------- */
  function scrollPct() {
    var de = document.documentElement, h = de.scrollHeight, vh = window.innerHeight;
    if (h <= vh) return 100;
    var pct = Math.round((window.pageYOffset + vh) / h * 100);
    return Math.max(0, Math.min(100, pct));
  }
  var scrollPending = false;
  function onScroll() {
    if (scrollPending) return;
    scrollPending = true;
    window.requestAnimationFrame(function () {
      scrollPending = false;
      var p = scrollPct();
      if (p > maxScrollPct) maxScrollPct = p;
      for (var i = 0; i < CFG.scrollMilestones.length; i++) {
        var m = CFG.scrollMilestones[i];
        if (p >= m && !firedMilestones[m]) {
          firedMilestones[m] = true;
          track('scroll_depth', { depth_pct: m, path: location.pathname });
        }
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });

  /* ---------------- 停留 / 可见性 / 心跳 ---------------- */
  function visibleMs() {
    if (document.visibilityState === 'visible') engagedMs += Date.now() - visibleSince;
    visibleSince = Date.now();
    return engagedMs;
  }
  function firePageExit(reason) {
    if (pageExitFired) return;
    pageExitFired = true;
    var dwell = Date.now() - PAGE_ENTER;
    track('page_exit', {
      reason: reason || 'unload',                 // unload / hidden / soft_nav
      dwell_ms: dwell,
      engaged_ms: visibleMs(),
      scroll_depth_pct: maxScrollPct,
      exit_url: location.href,
      events_on_page: pageEvents
    });
  }
  var pageEvents = 0;
  var _track = track;
  track = function (type, data, silent) {
    if (type !== 'page_exit' && type !== 'heartbeat') pageEvents++;
    return _track(type, data, silent);
  };

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'hidden') {
      firePageExit('hidden');
      flush(true);
    } else {
      visibleSince = Date.now();
    }
  });
  window.addEventListener('pagehide', function () { firePageExit('unload'); flush(true); });
  window.addEventListener('beforeunload', function () { firePageExit('unload'); flush(true); });

  setInterval(function () {
    if (document.visibilityState !== 'visible') return;
    track('heartbeat', { engaged_ms: visibleMs(), scroll_depth_pct: maxScrollPct, path: location.pathname });
  }, CFG.heartbeatMs);

  /* ---------------- 软导航检测（SPA/视图过渡/bfcache） ---------------- */
  setInterval(function () {
    if (location.href !== lastHref) {
      firePageExit('soft_nav');
      lastHref = location.href;
      onPageView('soft');
    }
  }, 1200);
  window.addEventListener('popstate', function () { setTimeout(function () { if (location.href !== lastHref) { lastHref = location.href; onPageView('popstate'); } }, 0); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) { lastHref = location.href; onPageView('bfcache'); } });

  /* ---------------- 全站点击捕获 ---------------- */
  function elPath(el) {
    var parts = [];
    while (el && el.nodeType === 1 && parts.length < 4) {
      var s = el.tagName.toLowerCase();
      if (el.id) { parts.unshift(s + '#' + el.id); break; }
      var cls = (el.getAttribute && el.getAttribute('class') || '').trim().split(/\s+/).filter(Boolean).slice(0, 2);
      if (cls.length) s += '.' + cls.join('.');
      parts.unshift(s);
      el = el.parentElement;
    }
    return parts.join('>');
  }
  if (CFG.trackClicks) {
    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || t === document.body || t === document.documentElement) return;
      var el = t.closest ? t.closest('a,button,input,select,textarea,[role=button],[data-zv-atc]') : null;
      if (!el) el = t;
      var a = el.closest ? el.closest('a[href]') : null;
      var href = a ? a.getAttribute('href') : '';
      var isOutbound = false, linkHost = '';
      if (href && /^https?:/i.test(href)) {
        linkHost = hostOf(href);
        isOutbound = linkHost !== location.hostname.replace(/^www\./, '').toLowerCase();
      }
      track('click', {
        tag: el.tagName ? el.tagName.toLowerCase() : '',
        element_path: elPath(el),
        text: ((el.textContent || el.value || '').trim().slice(0, 80) || el.getAttribute && el.getAttribute('aria-label') || ''),
        type: el.getAttribute && el.getAttribute('type') || '',
        href: href || '',
        is_outbound: isOutbound,
        outbound_host: isOutbound ? linkHost : '',
        x: e.clientX, y: e.clientY,
        viewport: window.innerWidth + 'x' + window.innerHeight,
        path: location.pathname,
        scroll_pct_at_click: maxScrollPct
      });
      if (isOutbound) track('outbound_click', { host: linkHost, href: href, text: (el.textContent || '').trim().slice(0, 80) });
      // 结账点击 → begin_checkout
      var path = href || '';
      if (/^\/checkout|\/cart/.test(path) || /checkout/i.test((el.textContent || '').slice(0, 40))) {
        if (/^\/checkout/.test(path)) beginCheckout('click');
      }
    }, true);
  }

  /* ---------------- 表单交互（邮箱订阅 / 搜索） ---------------- */
  if (CFG.trackForms) {
    document.addEventListener('focusin', function (e) {
      var el = e.target;
      if (!el || !el.tagName) return;
      var tag = el.tagName.toLowerCase();
      if (tag !== 'input' && tag !== 'textarea' && tag !== 'select') return;
      var type = (el.getAttribute('type') || '').toLowerCase();
      var name = (el.getAttribute('name') || '').toLowerCase();
      var form = el.form;
      var isEmail = type === 'email' || /email|subscribe|newsletter/.test(name);
      var isSearch = type === 'search' || /search|q/.test(name) || (form && /search/.test(form.getAttribute('action') || ''));
      var isCoupon = /coupon|discount|promo/.test(name);
      if (isEmail) track('form_focus', { field: 'email', form_action: form ? form.getAttribute('action') : '', path: location.pathname });
      if (isSearch) track('form_focus', { field: 'search', form_action: form ? form.getAttribute('action') : '', path: location.pathname });
      if (isCoupon) track('form_focus', { field: 'coupon', path: location.pathname });
    }, true);
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || form.tagName !== 'FORM') return;
      var hasEmail = form.querySelector && form.querySelector('input[type=email],input[name*=email i],input[name*=subscribe i]');
      var isSearch = form.querySelector && form.querySelector('input[type=search],input[name=q i]');
      if (hasEmail) track('email_signup', { form_action: form.getAttribute('action') || '', form_id: form.id || '', path: location.pathname });
      if (isSearch) {
        var q = isSearch.value || '';
        track('search', { query: q, path: location.pathname });
      }
    }, true);
  }

  /* ---------------- 电商漏斗：拦截 /cart/*.js 与 /checkout ---------------- */
  function money(cents) { return typeof cents === 'number' ? (cents / 100) : cents; }
  function handleCartResponse(action, json) {
    if (!json) return;
    if (action === 'add' && json.items && json.items.length) {
      for (var i = 0; i < json.items.length; i++) {
        var it = json.items[i];
        track('add_to_cart', {
          product_id: it.product_id, variant_id: it.variant_id,
          product_title: it.product_title || it.title, sku: it.sku || '',
          price: money(it.price), quantity: it.quantity, line_price: money(it.line_price),
          handle: it.handle || ''
        });
      }
    } else if (action === 'change' && json.items) {
      for (var j = 0; j < json.items.length; j++) {
        var c = json.items[j];
        track('update_cart', {
          product_id: c.product_id, variant_id: c.variant_id,
          product_title: c.product_title || c.title, quantity: c.quantity,
          removed: c.quantity === 0
        });
        if (c.quantity === 0) track('remove_from_cart', { product_id: c.product_id, variant_id: c.variant_id, product_title: c.product_title || c.title });
      }
    } else if (action === 'clear') {
      track('clear_cart', {});
    }
  }
  (function patchFetch() {
    if (!window.fetch) return;
    var orig = window.fetch;
    window.fetch = function () {
      var args = arguments;
      var url = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
      var m = /\/cart\/(add|change|update|clear)\.js/.exec(url);
      var p = orig.apply(this, args);
      if (m) {
        p.then(function (resp) {
          try { resp.clone().json().then(function (j) { handleCartResponse(m[1], j); }); } catch (e) { /* noop */ }
        }).catch(function () { /* noop */ });
      }
      return p;
    };
  })();
  (function patchXHR() {
    if (!window.XMLHttpRequest) return;
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this._zvUrl = url; return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      var xhr = this, m = this._zvUrl ? /\/cart\/(add|change|update|clear)\.js/.exec(this._zvUrl) : null;
      if (m) {
        this.addEventListener('load', function () {
          try { handleCartResponse(m[1], JSON.parse(xhr.responseText)); } catch (e) { /* noop */ }
        });
      }
      return origSend.apply(this, arguments);
    };
  })();

  function beginCheckout(reason) {
    track('begin_checkout', { reason: reason, path: location.pathname, cart_value: null });
    // 异步拉购物车金额（失败不影响主事件）
    try {
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          track('checkout_cart_snapshot', {
            item_count: cart.item_count, total_price: money(cart.total_price),
            currency: cart.currency, items: (cart.items || []).slice(0, 20).map(function (i) {
              return { product_id: i.product_id, variant_id: i.variant_id, title: i.product_title || i.title, quantity: i.quantity, price: money(i.price) };
            })
          });
        })
        .catch(function () { /* noop */ });
    } catch (e) { /* noop */ }
  }
  // 「立即购买」类按钮：点击后跳 /checkout 的，都算 begin_checkout
  if (!window.__ZVCheckoutPatched) {
    window.__ZVCheckoutPatched = true;
    document.addEventListener('click', function (e) {
      var el = e.target && e.target.closest ? e.target.closest('a,button') : null;
      if (!el) return;
      var txt = (el.textContent || '').toLowerCase();
      if (/check out|checkout|buy now|立即购买|结账/.test(txt) && !/\/checkout/.test(el.getAttribute('href') || '')) beginCheckout('button');
    }, true);
  }

  /* ---------------- 登录态识别 ---------------- */
  (function identifyCustomer() {
    var c = window.ZV_TRACK_CUSTOMER;
    if (!c || !c.id) return;
    track('identify', { customer_id: String(c.id), email_hash: c.email_hash || '' });
  })();

  /* ---------------- 离站意图 ---------------- */
  var exitIntentFired = false;
  document.addEventListener('mouseout', function (e) {
    if (exitIntentFired) return;
    if (!e.relatedTarget && !e.toElement && e.clientY <= 5) {
      exitIntentFired = true;
      track('exit_intent', { path: location.pathname, scroll_depth_pct: maxScrollPct, engaged_ms: visibleMs() });
      flush(false);
    }
  });

  /* ---------------- 前端错误 ---------------- */
  window.addEventListener('error', function (e) {
    track('js_error', {
      message: String(e.message || '').slice(0, 300),
      source: e.filename || '', line: e.lineno || 0, col: e.colno || 0,
      stack: (e.error && e.error.stack || '').slice(0, 500)
    });
  });
  window.addEventListener('unhandledrejection', function (e) {
    track('js_error', { message: 'unhandledrejection: ' + String((e.reason && e.reason.message) || e.reason || '').slice(0, 300) });
  });

  /* ---------------- 对外 API（手动埋点用） ---------------- */
  window.ZVTrack = {
    track: track,
    flush: flush,
    getUserId: function () { return UID; },
    getSessionId: function () { return SESS.sid; },
    getFingerprint: function () { return FP; },
    version: '1.0.0'
  };

  /* ---------------- 启动 ---------------- */
  onPageView(reason0());
  function reason0() {
    // 性能 API 的 navigation type：navigate / reload / back_forward
    try {
      var n = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
      if (n && n.type === 'reload') return 'reload';
      if (n && n.type === 'back_forward') return 'back_forward';
    } catch (e) { /* noop */ }
    return 'landing';
  }
  setInterval(function () { flush(false); }, CFG.batchMs);
  // 离线恢复：网络回来立即补发
  window.addEventListener('online', function () { flush(false); });
  log('[zv-track] 初始化完成 uid=' + UID + ' fp=' + FP + ' sid=' + SESS.sid);
})(window, document, navigator);
